module.exports = __webpack_public_path__ + "static/media/SecurityTrackerLogo.0a845dd7.png";